module.exports = __webpack_public_path__ + "img/menucn_4_7.2932ea84.svg";